import React, { useMemo } from "react";
import MultiSelectDropdown from "app/components/MultiSelectDropdown";
import DropdownButton from "app/containers/Features/containers/Home/components/TicketFilters/DropdownButton";
import clsx from "clsx";
import TicketsIcon from "app/components/Icons/TicketsIcon";

import { FilterOption } from "app/containers/Features/containers/Home/type";

interface Props {
  selectedIds: string[];
  onUpdate: (values: string[]) => void;
  options: FilterOption[];
  alignDropdownRight?: boolean;
}

const ProjectFilter: React.FC<Props> = ({
  selectedIds,
  onUpdate,
  options,
  alignDropdownRight = false,
}) => {
  const isAllSelected = options.length > 0 && selectedIds.length === options.length;

  const selectedNames = selectedIds.map(
    (id) => options.find((o) => o.id === id)?.value || id,
  );

  const triggerButton = (
    <button
      className={clsx(
        "text-sm font-normal text-primary h-[32px] max-w-[400px] min-w-[157px] flex items-center justify-between gap-[6px] bg-white border rounded-[54px] px-[10px] text-ellipsis whitespace-nowrap overflow-hidden outline-none pointer-events-auto",
        isAllSelected || selectedIds.length
          ? "border-primary"
          : "border-secondary",
      )}
    >
      <DropdownButton
        icon={<TicketsIcon size={14} />}
        isAllSelected={isAllSelected}
        selectedItems={selectedIds}
        selectedItemNames={selectedNames}
        title="Project:"
      />
    </button>
  );

  const trigger = alignDropdownRight ? (
    <div className="flex w-80 justify-end pointer-events-none">
      {triggerButton}
    </div>
  ) : (
    triggerButton
  );

  return (
    <div className={clsx("relative", alignDropdownRight && "pr-6 -mr-6")}>
      <MultiSelectDropdown
        title="Project"
        options={options}
        selectedOptions={selectedIds}
        setSelectedOptions={onUpdate}
        searchPlaceholder="Search Projects"
        trigger={trigger}
      />
    </div>
  );
};

export default ProjectFilter;
